import { WidgetDataSource } from '../../../../../../../models';
import {
  Comparison,
  Widget,
  WidgetGroup,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { Utils } from '../../../../../../../utils/utils';
import { BigNumberWidgetOptions } from '../../../../widget-big-number/widget-big-number.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class BigNumberPointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<BigNumberWidgetOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison
  ): AiInsightPayloadParams {
    const payload = super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison
    );

    const getOptionForPoint = ((fieldOnePayload, fieldTwoPayload) => (point, option) =>
      point.custom.payloadIndex === 0 ? fieldOnePayload[option] : fieldTwoPayload[option])(
      {
        scoringStrategy: widget.payload.scoringStrategy ?? 'AVERAGE',
        boxDirection: widget.payload.boxDirection,
        boxSize: widget.payload.boxSize,
        scoreRange: widget.payload.scoreRange,
        analyticItem: widget.payload.analyticItem,
      },
      {
        scoringStrategy: widget.payload.scoringStrategyTwo ?? 'AVERAGE',
        boxDirection: widget.payload.boxDirectionTwo,
        boxSize: widget.payload.boxSizeTwo,
        scoreRange: widget.payload.scoreRangeTwo,
        analyticItem: widget.payload.analyticItemTwo,
      }
    );

    const flattenedPoints = selectedPoints.flat();
    for (let pointIdx = 0; pointIdx < flattenedPoints.length; pointIdx++) {
      const point = flattenedPoints[pointIdx];
      const bucket = payload.buckets[pointIdx];
      bucket.analytic_item_type = FieldService.getFieldShortName(
        getOptionForPoint(point, 'analyticItem')
      );
      bucket.analytic_item_value = point.y;
      bucket.aggregate_rating_score = point.y;

      bucket.metric_calculation = getOptionForPoint(point, 'scoringStrategy');
      bucket.rating_field = bucket.analytic_item_type;
      const scoreRange = getOptionForPoint(point, 'scoreRange');
      if (scoreRange) {
        bucket.worst_rating_value = scoreRange.split(':')[0];
        bucket.best_rating_value = scoreRange.split(':')[1];
      }

      switch (bucket.metric_calculation) {
        case 'NPS':
          bucket.metric_calculation = 'rating';
          bucket.rating_score_high = 100;
          bucket.rating_score_low = -100;
          break;
        case 'BOX':
          bucket.rating_score_high = 100;
          bucket.rating_score_low = 0;
          bucket.box_options = `${Utils.titleCase(
            getOptionForPoint(point, 'boxDirection')
          )}:${getOptionForPoint(point, 'boxSize')}`;
          break;
        case 'AVERAGE':
          bucket.rating_score_high = bucket.best_rating_value;
          bucket.rating_score_low = bucket.worst_rating_value;
          break;
      }
    }

    return payload;
  }
}
